import { useSelector } from "react-redux";

const useLoggedIn = () => {
  const { isAuthenticated, user } = useSelector((state) => state.auth);

  // redux-persist rehydration flag — stays false until store is fully loaded from localStorage
  const rehydrated = useSelector((state) => state._persist?.rehydrated ?? true);

  const isLoading = !rehydrated;
  const isLoggedIn = isAuthenticated && !!user;

  return { isLoggedIn, isLoading };
};

export default useLoggedIn;

